// extracted by mini-css-extract-plugin
module.exports = {"box":"mobile-topbar_box__3i45h"};